import BaseModule from '../../../javascripts/helpers/baseModule';

// Accordion module based on the wai-aria best practises https://www.w3.org/TR/wai-aria-practices/examples/accordion/accordion.html
export default class Accordion extends BaseModule {
  constructor(element) {
    super(element, element.getAttribute('data-js-module'));

    this.getElements([
      { id: 'controls', selector: 'control' },
      { id: 'panels', selector: 'panel' }
    ]);
    this.bindControlEvents();
  }

  static isCollapsed(element) {
    return element.getAttribute('aria-expanded') !== 'true';
  }

  static unfold(control, panel) {
    panel.removeAttribute('hidden');
    panel.removeAttribute('aria-hidden');
    control.setAttribute('aria-expanded', 'true');
  }

  static collapse(control, panel) {
    panel.setAttribute('hidden', '');
    panel.setAttribute('aria-hidden', 'true');
    control.setAttribute('aria-expanded', 'false');
  }

  bindControlEvents() {
    this.elements.controls.asList.forEach((control, controlIndex) => {
      control.addEventListener('click', (event) => {
        event.preventDefault();

        const clickTarget = event.target;
        const panel = this.elements.panels.asList[controlIndex];

        const isCollapsed = this.constructor.isCollapsed(clickTarget);

        if (isCollapsed) {
          this.constructor.unfold(clickTarget, panel);
        } else {
          this.constructor.collapse(clickTarget, panel);
        }
      });

      control.addEventListener('keydown', (event) => {
        const focusTarget = event.target;
        const panel = this.elements.panels.asList[controlIndex];

        const controlCount = this.elements.controls.length;

        switch (event.key) {
          // When focus is on an accordion header, moves focus to the next accordion header.
          // When focus is on last accordion header, moves focus to first accordion header.
          case 'ArrowUp':
          case 'PageUp': {
            event.preventDefault();

            const newIndex = (controlIndex + controlCount - 1) % controlCount;
            this.elements.controls[newIndex].focus();
            break;
          }
          // When focus is on an accordion header, moves focus to the previous accordion header.
          // When focus is on first accordion header, moves focus to last accordion header.
          case 'ArrowDown':
          case 'PageDown': {
            event.preventDefault();

            const newIndex = (controlIndex + controlCount + 1) % controlCount;
            this.elements.controls[newIndex].focus();
            break;
          }
          // When focus is on an accordion header, moves focus to the first accordion header.
          case 'Home': {
            event.preventDefault();

            this.elements.controls[0].focus();
            break;
          }
          // When focus is on an accordion header, moves focus to the last accordion header.
          case 'End': {
            event.preventDefault();

            this.elements.controls[this.elements.controls.length - 1].focus();
            break;
          }
          // When focus is on the accordion header of a collapsed section, expands the section.
          case ' ':
          case 'Enter': {
            event.preventDefault();
            const isCollapsed = this.constructor.isCollapsed(event.target);
            if (isCollapsed) {
              this.constructor.unfold(focusTarget, panel);
            } else {
              this.constructor.collapse(focusTarget, panel);
            }
            break;
          }
          default: {
            break;
          }
        }
      });
    });

    this.elements.panels.asList.forEach((panel, panelIndex) => {
      panel.addEventListener('keydown', (event) => {
        switch (event.key) {
          case 'PageUp': {
            event.preventDefault();

            // When focus is inside an accordion panel, moves focus to the header for that panel.
            this.elements.controls[panelIndex].focus();
            break;
          }
          case 'PageDown': {
            event.preventDefault();

            // When focus is inside an accordion panel moves focus to the next accordion header.
            // When focus is inside last accordion panel, moves focus to first accordion header.
            if (this.elements.controls[panelIndex + 1]) {
              this.elements.controls[panelIndex + 1].focus();
            } else {
              this.elements.controls[0].focus();
            }
            break;
          }
          default: {
            break;
          }
        }
      });
    });
  }
}
